// Ported from vlookup-dramatic/components/video-dialog.tsx by scripts/revamp/port-design.js
import React, { useState } from "react";
import { Play, X } from "../lib/icons";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { heroVideo } from "../lib/content";
import { cn } from "../lib/utils";
// Turn a YouTube/Vimeo link into an embeddable iframe src; otherwise treat as a file.
function resolve(url) {
    const yt = url.match(/(?:youtu\.be\/|[?&]v=|\/embed\/)([\w-]{11})/);
    if (yt)
        return {
            type: "iframe",
            src: `https://www.youtube-nocookie.com/embed/${yt[1]}?autoplay=1&rel=0&modestbranding=1`,
        };
    const vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vm)
        return { type: "iframe", src: `https://player.vimeo.com/video/${vm[1]}?autoplay=1` };
    return { type: "video", src: url };
}
// `url` overrides the design's sample video (Home passes setting.video_link).
export function VideoDialog({ url, triggerClassName, iconClassName, }) {
    const [open, setOpen] = useState(false);
    const media = resolve(url || heroVideo.url);
    return (<>
      <button type="button" aria-label={heroVideo.title} onClick={() => setOpen(true)} className={cn("group flex items-center justify-center rounded-full bg-brand-red text-white shadow-lg transition-transform hover:scale-110 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-brand-red/40", triggerClassName)}>
        <Play className={cn("size-6 translate-x-0.5 fill-white text-white", iconClassName)}/>
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent showCloseButton={false} className="max-w-[min(64rem,calc(100%-2rem))] gap-0 overflow-hidden rounded-2xl border-0 bg-black p-0 ring-0 shadow-2xl sm:max-w-4xl">
          <DialogTitle className="sr-only">{heroVideo.title}</DialogTitle>
          <button type="button" aria-label="Close video" onClick={() => setOpen(false)} className="absolute right-3 top-3 z-10 flex size-9 items-center justify-center rounded-full bg-black/60 text-white backdrop-blur transition-colors hover:bg-black/85">
            <X className="size-5"/>
          </button>
          <div className="relative aspect-video w-full bg-black">
            {open &&
            (media.type === "iframe" ? (<iframe className="absolute inset-0 h-full w-full" src={media.src} title={heroVideo.title} allow="autoplay; encrypted-media; picture-in-picture; fullscreen; clipboard-write; web-share" allowFullScreen/>) : (<video className="absolute inset-0 h-full w-full" src={media.src} poster={heroVideo.poster || undefined} controls autoPlay playsInline/>))}
          </div>
        </DialogContent>
      </Dialog>
    </>);
}
